var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconLaunchBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37069 3.96125C5.27942 6.3088 3.84424 9.68148 3.71097 9.99927L0 8.41032L4.15178 4.25854C4.63359 3.77673 5.33068 3.56145 6.00726 3.69472L7.37069 3.96125ZM9.40044 14.8789C9.40044 14.8789 13.2344 13.2899 15.4385 11.0859C20.9742 5.5502 20.0515 1.22415 19.7543 0.250281C18.7804 -0.0572583 14.4543 -0.969624 8.91863 4.56608C6.7146 6.77011 5.12565 10.6041 5.12565 10.6041L9.40044 14.8789ZM16.0433 12.6339C13.6957 14.7251 10.3231 16.1603 10.0053 16.2936L11.5942 20.0045L15.746 15.8528C16.2278 15.371 16.4431 14.6739 16.3098 13.9973L16.0433 12.6339ZM7.17591 15.904C7.17591 16.7549 6.82737 17.5237 6.2738 18.0773C5.06414 19.2869 0 20.0045 0 20.0045C0 20.0045 0.717591 14.9404 1.92725 13.7307C2.35657 13.2992 2.90445 13.0049 3.50133 12.8853C4.09821 12.7658 4.71716 12.8263 5.2796 13.0591C5.84203 13.292 6.32257 13.6868 6.66021 14.1933C6.99784 14.6998 7.17734 15.2953 7.17591 15.904ZM11.2764 6.67785C11.2764 5.5502 12.199 4.62759 13.3267 4.62759C14.4543 4.62759 15.377 5.5502 15.377 6.67785C15.377 7.80549 14.4543 8.72811 13.3267 8.72811C12.199 8.72811 11.2764 7.80549 11.2764 6.67785Z",
    fill: "#02215F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconLaunchBlue);
export default __webpack_public_path__ + "static/media/buttonIconLaunchBlue.784a7ae000fcc41910cb65e54f92c7e1.svg";
export { ForwardRef as ReactComponent };